"use client";

import { Instagram } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Advocates() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const instructors = [{
    name: "SARAH JENKINS",
    role: "LEAD NEGOTIATOR",
    credentials: "Former corporate procurement director. 20 years of high-stakes contract negotiation experience.",
    certs: "MBA / CPN / STRAT",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1723817/img/lead_negotiator_sarah.webp",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1723817/img/lead_negotiator_sarah.webp-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1723817/img/lead_negotiator_sarah.webp-wvc-sizes"
  }, {
    name: "MARCUS THORNE",
    role: "MARKET ANALYST",
    credentials: "Data-driven pricing expert. Specializes in automotive and real estate market valuation.",
    certs: "CFA / DATA / MKT",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1723817/img/market_analyst_marcus.webp",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1723817/img/market_analyst_marcus.webp-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1723817/img/market_analyst_marcus.webp-wvc-sizes"
  }, {
    name: "ELENA RODRIGUEZ",
    role: "CONSUMER ADVOCATE",
    credentials: "Legal background with a focus on consumer protection laws and fair trade practices.",
    certs: "JD / CONS / LAW",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1723817/img/consumer_advocate_elena.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1723817/img/consumer_advocate_elena.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1723817/img/consumer_advocate_elena.png-wvc-sizes"
  }, {
    name: "DAVID CHEN",
    role: "STRATEGY DIRECTOR",
    credentials: "Expert in luxury asset acquisition. Master of identifying hidden value in complex deals.",
    certs: "MBA / LUX / STRAT",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1723817/img/strategy_director_david.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1723817/img/strategy_director_david.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1723817/img/strategy_director_david.png-wvc-sizes"
  }];
  return <section data-section-id="2154" id="the-advocates" className="bg-background text-foreground py-20 md:py-28 px-6 md:px-10">
      <div ref={ref} className={`max-w-7xl mx-auto transition-all duration-700 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
        {}
        <div className="mb-16 md:mb-20">
          <p className="font-default text-xs uppercase tracking-widest text-foreground mb-6">
            [ OUR EXPERTS / 03 ]
          </p>
          <h2 className="font-default font-bold uppercase text-5xl md:text-7xl lg:text-8xl leading-[0.9] text-primary mb-6">
            <span className="inline-block w-3 h-3 bg-accent-orange mr-2 mb-2" />
            MEET THE
            <br />
            <span className="text-transparent" style={{
            WebkitTextStroke: "1.5px var(--primary)"
          }}>
              ADVOCATES
            </span>
          </h2>
          <p className="font-default italic text-xl md:text-2xl text-foreground/80 max-w-2xl">
            — Dedicated professionals fighting for your best price.
          </p>
        </div>

        {}
        <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 gap-8 md:gap-6 mb-16">
          {instructors.map((person, i) => <div key={i} data-index={i} className="group border border-border bg-card shadow-md hover:shadow-lg transition-all duration-300 flex flex-col rounded-lg">
              {}
              <div className="relative overflow-hidden rounded-t-lg">
                <div className="absolute left-0 top-0 bottom-0 w-[4px] z-10 bg-accent-orange" />
                <div className="aspect-[3/4] overflow-hidden bg-muted">
                  <img src={person.image} data-wvc-srcset={person.srcset} data-wvc-sizes={person.sizes} alt={person.name} loading="lazy" decoding="async" className="w-full h-full object-cover grayscale group-hover:grayscale-0 transition-all duration-500" />
                </div>
              </div>

              {}
              <div className="bg-card p-5 flex flex-col gap-3 flex-1 relative rounded-b-lg">
                <p className="font-default text-[10px] uppercase tracking-widest text-accent-orange font-bold">
                  {person.role}
                </p>
                <h3 className="font-default font-bold uppercase text-[22px] leading-tight text-primary">
                  {person.name}
                </h3>
                <div className="h-px w-full bg-border" />
                <p className="font-default text-sm leading-snug text-foreground/85 line-clamp-2">
                  {person.credentials}
                </p>
                <div className="flex items-center justify-between mt-auto pt-2">
                  <p className="font-default text-[10px] uppercase tracking-widest text-foreground/60">
                    {person.certs}
                  </p>
                  <Link to="/AboutContactPage" aria-label={`${person.name} profile`} className="text-primary hover:text-accent-orange transition-colors">
                    <Instagram className="size-4" />
                  </Link>
                </div>
              </div>
            </div>)}
        </div>

        {}
        <div className="flex justify-center">
          <Button asChild variant="outline" size="lg" className="border-2 border-secondary text-secondary hover:bg-secondary hover:text-white font-default font-bold uppercase text-xs tracking-widest px-8 h-12 rounded-lg shadow-md transition-all">
            <Link to="/AboutContactPage">VIEW FULL TEAM →</Link>
          </Button>
        </div>
      </div>
    </section>;
}